import { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useStore } from '@shared/hooks/useStore';
import ReaderBookmarkList from './ReaderBookmarkList';
import ReaderNoteList from './ReaderNoteList';
import ReaderMobileHeader from './ReaderMobileHeader';

type TabType = 'bookmarks' | 'notes';

const ReaderBookmarkNoteSidebar = observer(() => {
    const { readerStore } = useStore();
    const [activeTab, setActiveTab] = useState<TabType>('bookmarks');

    const handleTabClick = (tab: TabType) => {
        setActiveTab(tab);
    };

    const handleDelete = (id: string, type: TabType) => {
        if (type === 'bookmarks') {
            readerStore.removeBookmark(id);
        } else {
            readerStore.removeNote(id);
        }
    };

    const handleItemClick = (pageNumber: number) => {
        const activeBook = readerStore.getActiveBook();
        if (activeBook) {
            readerStore.fetchPage(activeBook.publication.id, pageNumber);

            if (window.innerWidth < 640) {
                readerStore.setIsBookmarkNoteOpen(false);
            }
        }
    };

    return (
        <div className='min-h-full flex flex-col w-full border border-[#FFFFFF1A] text-white p-4 gap-4'>
            {/* Header - mobile only */}
            <div className='sm:hidden'>
                <ReaderMobileHeader title='一覧' onClose={() => readerStore.toggleBookmarkNote()} />
            </div>

            {/* Tabs */}
            <div className='flex'>
                <button
                    onClick={() => handleTabClick('bookmarks')}
                    className={`flex-1 pb-4 leading-[21px] transition-colors border-b-[2px] ${activeTab === 'bookmarks' ? 'text-primary font-medium border-primary' : 'text-[#FFFFFF80] border-[#D9D9D9]'}`}
                >
                    ブックマーク
                </button>
                <button
                    onClick={() => handleTabClick('notes')}
                    className={`flex-1 pb-4 leading-[21px] transition-colors border-b-[2px] ${activeTab === 'notes' ? 'text-primary font-medium border-primary' : 'text-[#FFFFFF80] border-[#D9D9D9]'}`}
                >
                    メモ
                </button>
            </div>

            {/* List */}
            <div className='flex-1 overflow-y-auto custom-scrollbar'>
                {activeTab === 'bookmarks' ?
                    (
                        <ReaderBookmarkList
                            onItemClick={handleItemClick}
                            onDelete={id => handleDelete(id, 'bookmarks')}
                        />
                    ) :
                    (
                        <ReaderNoteList
                            onItemClick={handleItemClick}
                            onDelete={id => handleDelete(id, 'notes')}
                        />
                    )}
            </div>
        </div>
    );
});

export default ReaderBookmarkNoteSidebar;
